import { breakPoints } from '@/utility/mediaQuery';

// breakPointsに応じたサイズの画像を取得したい場合のsrcsetを生成する
export const parseCmsSrcset = ({
  imageUrl,
  offset,
  format,
}: {
  imageUrl: string;
  offset?: number;
  format?: string;
}) => {
  return Object.values(breakPoints)
    .map(
      bp =>
        `${imageUrl}?w=${bp + (offset || 0)}${
          format ? `&fm=${format}` : ''
        } ${bp}w`,
    )
    .join(', ');
};
